<template>
  <section class="about-section pc-about" id="about">
    <header class="about-section-header section-title-wrapper">
      <h1 class="section-title" v-text="$t('home.about_us_title')"></h1>
      <h2 class="section-sub-title" v-text="$t('home.about_us_sub_title')"></h2>
    </header>
    <div class="introduction">
      <div class="introduction-title" v-text="$t('home.what_is_mixmarvel')"></div>
      <div class="introduction-sub-title" v-text="$t('home.mixmarvel_exp1')"></div>
      <div class="introduction-meta" v-html="$t('home.mixmarvel_exp2')+'<br>'+$t('home.mixmarvel_exp3')">
      </div>
    </div>
    <div class="video-container">
      <div class="video-phone">
        <div class="video-wrapper" :class="{'isPlay':isPlay}">
          <video
            id="video"
            :src="video_url"
            poster="../../../assets/img/video_thum.png"
            v-text="$t('video_support')"
          ></video>
          <div class="play-btn" @click="togglePlay">
            <img src="../../../assets/img/play.png" :alt="$t('play_btn')" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {animationScroll} from '@/assets/js/common'
export default {
  data() {
    return {
      isPlay: false,
      video_url:'https://cn-hangzhou-h-website-prod-1.obs.cn-east-3.myhuaweicloud.com/video/MixMarvel_1080p_0816Final_cn.mp4',
    };
  },
  methods: {
    togglePlay() {
      let videoObj = document.getElementById("video");
      if (videoObj.paused) {
        // 如果视频处于播放状态
        videoObj.play();
        videoObj.controls = "controls";
        this.isPlay = true;
      }
    },
    videoListenerInit() {
      var that = this;
      // 监听video的事件
      var videoObj = document.getElementById('video')
      // videoObj.addEventListener("pause", function() {
      //   console.log(videoObj.isPlay)
      //   that.isPlay = false;
      //   videoObj.controls = false;
      // });
      videoObj.addEventListener("ended", function() {
        that.isPlay = false;
        videoObj.controls = false;
      });
    }
  },
  mounted() {
    this.videoListenerInit();
    animationScroll($('.about-section'));
    var lang = this.$cookies.get('language');
    if(lang == 'en'||lang == 'kr'){
      this.video_url = 'https://cn-hangzhou-h-website-prod-1.obs.cn-east-3.myhuaweicloud.com/video/MixMarvel_1080p_0816Final_en.mp4'
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/index/aboutUsSection.vue